<template>
    <footer class="footer">
        <div class="container has-text-centered">
            <div class="copyright">
                <strong>Transición Digital &copy; {{ date.getFullYear() }}</strong>, Derechos reservados, Powered by <a
                    href="https://lapi.com.mx" target="_blank">Laboratorios Lapi</a>.
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "MainFooter",
        data() {
            return {
                date: new Date()
            }
        }
    }
</script>

<style scoped>

</style>
